import React from 'react';
import { Layout, Text, Icon, Button, Card, RadioGroup, Radio, CheckBox, Input } from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY_AND_RESPONSE_COUNT } from '../../data/api/query/q_survey';
import { ListRenderItemInfo, StyleSheet, View, FlatList, Platform } from 'react-native';
import { ItemTypeHeader } from '../../components/list-items/CardItem';
import { SurveySection, Question, AnswerGroup, Answer } from '../../data/models/types';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { getPublicSurveyUrl } from '../../utils/LinkHelpers';
import { BasicCard } from '../../components/_primatives';



export default function SurveyScreen({ navigation, route }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger, bodyWidth, pageSpacerHorizontal } = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const surveyId: string = params.survey;
    const queryParams: any = {
        survey_id: surveyId,
        // org_id: null,
        // user_id: USER_ID
    };
    console.log('using params', queryParams);
    const { loading, error, data, refetch } = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, {
        variables: queryParams,
        fetchPolicy: 'network-only'
    });
    React.useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            // The screen is focused
            console.log('const unsubscribe = navigation.addListener(focus, () => refetch();')
            refetch();
        });

        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe;
    }, [navigation]);

    if (loading) return <PageLoadingIndicator />;
    if (error) {
        console.log('useQuery', error);
        return <Text>Error :(</Text>
    };
    console.log('we have data, ', data)
    const { title, description, instructions, start_date, end_date, is_open, campaign_id } = data.surveys[0];
    const surveyParticipantCount: number = data.surveys[0].user_answers_aggregate.aggregate.count + data.surveys[0].anon_user_answers_aggregate.aggregate.count;
    const surveySections: any = data.surveys[0].survey_sections;
    console.log('list data (data.surveys[0].survey_sections;) = ', surveySections);

    const onEditPress = async () => {
        if (surveyParticipantCount > 0) {
            alert('You can\'t make edits after a user have responded');
        }
        else {
            navigation.navigate('ManageSurvey', { survey_id: surveyId });
        }
    };

    const renderItem = ({ item }: ListRenderItemInfo<SurveySection>) => {
        return (
            <View key={item.id}>
                {item.questions.map((question: Question) =>
                    <BasicCard key={question.id} style={{ marginBottom: 10, borderWidth: 0}}>
                        <Text category='s1'>{question.question_title}</Text>
                        {question.answer_groups.map((ag: AnswerGroup) =>
                            <Layout key={ag.id}>
                                {
                                    question.question_type === 'select' ?
                                        <>
                                            <RadioGroup selectedIndex={undefined} onChange={() => { }}>
                                                {ag.possible_answers.map((answer: Answer) =>
                                                    <Radio
                                                        key={answer.id}
                                                        text={
                                                            answer.answer_text + ' '
                                                            // + answer.id
                                                        }
                                                        style={{ marginVertical: 8 }}
                                                    />
                                                )}
                                            </RadioGroup>
                                        </>
                                        : question.question_type === 'multiselect' ?
                                            <>
                                                {ag.possible_answers.map((answer: Answer) =>
                                                    <CheckBox
                                                        style={{ marginVertical: 8 }}
                                                        text={
                                                            answer.answer_text + ' '
                                                            // + answer.id
                                                        }
                                                        key={answer.id}
                                                    />
                                                )}
                                            </>
                                            : question.question_type === 'text' ?
                                                <>
                                                    {ag.possible_answers.map((answer: Answer) =>
                                                        <Input
                                                            style={{ marginVertical: 8 }}
                                                            value={
                                                                answer.answer_text + ' '
                                                                // + answer.id
                                                            }
                                                            key={answer.id}
                                                        />
                                                    )}
                                                </>
                                                : undefined
                                }
                            </Layout>
                        )}
                    </BasicCard>
                )}
            </View>
        );
    };


    const publicSurveyUrl: string = getPublicSurveyUrl(surveyId);

    const renderHeader = (): React.ReactElement => (
        <View style={{ marginVertical: 20, paddingHorizontal: 23 }}>
            {/* marginLeft: 25, marginBottom: 25, marginTop: 50 */}
            <ItemTypeHeader title=' SURVEY' icon='clipboard-outline' />
            <Text category='h1'>{title}</Text>
            <Text category='s1'>{description}</Text>
            {/* <Text category='p1' appearance='hint'>{`Survey is ${is_open ? 'active' : 'inactive'}`}: {(new Date(start_date).toLocaleDateString()) + ' - ' + (new Date(end_date).toLocaleDateString())}</Text> */}
            <Text category='p1' appearance='hint' style={{ marginBottom: 15 }}>{instructions}</Text>
            <Input
                label={'Survey Link'}
                value={publicSurveyUrl}
                style={{ flex: 1, marginBottom: 20 }}
                // status='primary'
                placeholder='Primary'
            />
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                <Button
                    onPress={() => navigation.navigate('SurveyResults', { survey_id: surveyId })}
                    // status='basic'
                    icon={(style) => <Icon {...style} name='bar-chart-outline' style={{ transform: [{ rotate: '90deg'}] }} />}
                    style={{ marginRight: 10, marginBottom: 10 }}
                >
                    {`${surveyParticipantCount} Results`}
                </Button>
                {Platform.OS === 'web' ?
                    <Button
                        // status='basic'
                        icon={(style) => <Icon {...style} name='external-link' />}
                        accessibilityRole='link'
                        href={publicSurveyUrl}
                        target='_blank'
                        style={{ marginRight: 10, marginBottom: 10 }}
                    >
                        {`Open Survey`}
                    </Button>
                    : <Button
                        onPress={() => navigation.navigate('TakeSurvey', { screen: 'Survey', params: { survey_id: surveyId } })}
                        // status='basic'
                        icon={(style) => <Icon {...style} name='external-link' />}
                        style={{ marginRight: 10, marginBottom: 10 }}
                    >
                        {`Open Survey`}
                    </Button>
                }
                {Platform.OS === 'web' ?
                    <Button
                        onPress={onEditPress}
                        // status='basic'
                        icon={(style) => <Icon {...style} name='edit-outline' />}
                        style={{ marginBottom: 10 }}
                    >
                        {`Edit`}
                    </Button>
                    : undefined
                }
            </View>
        </View>
    );

    const renderFooter = () => (
        <View style={{ height: 100 }}>
        </View>
    );

    {
        Platform.OS !== 'web' && navigation.setOptions({
            headerRight: () => (
                <Button
                    onPress={onEditPress}
                    appearance='ghost'
                    status='basic'
                    icon={(style) => <Icon {...style} name='edit-outline' />}
                    style={{ marginLeft: 0, marginRight: 10 }}
                >
                    {Platform.OS === 'web' ? 'Edit' : undefined}
                </Button>
            )
        })
    };

    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                // data={surveySections}
                data={[]}
                renderItem={renderItem}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
            />
        </Layout>
    );
}






// import { Linking } from "expo";

// interface AnchorProps {
//     href: string;
//     target: string;
//     onPress: string;
//     children: string;
// }

// export class Anchor extends React.Component<AnchorProps> {
//     _handlePress = () => {
//         // WebBrowser.openBrowserAsync(this.props.href)
//         Linking.canOpenURL(this.props.href, this.props.target)
//             .then(supported => {
//                 if (!supported) {
//                     console.log("Can't handle url: " + this.props.href, this.props.target);
//                 }
//                 else {
//                     if (window) {
//                         return window.open(this.props.href, this.props.target);
//                     }
//                     else {
//                         return Linking.openURL(this.props.href, this.props.target);
//                     }
//                 }
//             })
//             .catch((err) =>{
//                 console.error("An error occurred", err);
//             });
//         this.props.onPress && this.props.onPress();
//     };

//     render() {
//         return (
//             <Text {...this.props} onPress={this._handlePress}>
//                 {this.props.children}
//             </Text>
//         );
//     }
// }